import { z } from 'zod';
import { initContract } from '@ts-rest/core';
const c = initContract();
export const cloudStorageContract = c.router(
  {
    getReadUrl: {
      method: 'POST',
      path: '/get-read-url',
      responses: {
        200: z.object({
          readUrl: z.string(),
        }),
      },
      body: z.object({
        fileName: z.string(),
      }),
      summary: 'Get file upload url',
    },
    getFileUploadUrl: {
      method: 'POST',
      path: '/file-upload-url',
      responses: {
        200: z.object({
          storageObjectName: z.string(),
          uploadUrl: z.string(),
        }),
      },
      body: z.object({
        fileName: z.string(),
        contentType: z.string(),
        timestamp: z.boolean(),
      }),
      summary: 'Get file upload url',
    },
  },
  {
    strictStatusCodes: true,
    pathPrefix: '/cloud-storage',
  },
);
